import { render, staticRenderFns } from "./Rightsli.vue?vue&type=template&id=a1a426dc&scoped=true&"
import script from "./Rightsli.vue?vue&type=script&lang=js&"
export * from "./Rightsli.vue?vue&type=script&lang=js&"
import style0 from "./Rightsli.vue?vue&type=style&index=0&id=a1a426dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a426dc",
  null
  
)

export default component.exports